/**
 * GitHub 저장소 메타데이터 — 배포 실패 시 Actions run 링크를 조립할 때 사용.
 * fork / rename 대응을 위해 상수로 분리했다. 추후 필요 시 `VITE_GH_OWNER` /
 * `VITE_GH_REPO` 환경변수 override 를 여기서 처리하면 된다.
 */
export const GH = {
  owner: 'JokerTrickster',
  repo: 'Luzer',
} as const;

/** Build the GitHub Actions run page URL for a given run_id. */
export function buildRunURL(runID: number): string {
  return `https://github.com/${GH.owner}/${GH.repo}/actions/runs/${runID}`;
}
